import React from 'react';
import { Header } from './header';
import { Sidebar } from './sidebar';
import { OrgSuspendedModal } from './org-suspended-modal';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="relative flex h-screen flex-col bg-background">
      <img
        src="/web.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none fixed -left-5 -top-5 z-0 h-[700px] w-[700px] select-none opacity-[0.12]"
        style={{ maskImage: 'radial-gradient(circle at 0% 0%, black 25%, transparent 75%)', WebkitMaskImage: 'radial-gradient(circle at 0% 0%, black 25%, transparent 75%)' }}
      />
      <div className="relative z-10 flex h-screen flex-col">
        <Header />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar />
          <main className="flex-1 overflow-y-auto p-6">
            {children}
          </main>
        </div>
      </div>
      {/* Blocking overlay — locks the whole shell when the org is suspended. */}
      <OrgSuspendedModal />
    </div>
  );
}
